import { useState, useRef } from 'react'

import { apiService } from 'lib/services/api'
import { serializeFormData } from 'lib/utils/form'
import type { ApiError } from 'lib/types/api'
import type { FormErrors, SignInFormData } from 'lib/types/forms'

export const useSignInForm = () => {
  const formRef = useRef<HTMLFormElement>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState<FormErrors>({})

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!formRef.current || isSubmitting) return

    setErrors({})
    setIsSubmitting(true)

    try {
      const formData = serializeFormData<SignInFormData>(formRef.current)
      await apiService.signIn(formData)

      window.location.href = '/partner'
    } catch (error) {
      const apiError = error as ApiError
      setErrors(apiError)
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    formRef,
    isSubmitting,
    errors,
    handleSubmit,
  }
}
